export default __webpack_public_path__ + "static/media/bg-img.1337a95d.png";